<template>
    <div
        v-if="isVisible"
        v-qa="'cookie-banner'"
        class="cookies-banner"
    >
        <p class="message">
            <!--                        TODO Translate-->
            This website uses cookies. For more information, please read our
            <ThLink
                :to="'/cookies'"
                target="_blank"
                aria-label="cookies policy - opens in a new tab"
            >
                cookies policy.
            </ThLink>
        </p>

        <div class="cookie-button-wrapper">
            <button
                v-qa="'close-cookie-banner'"
                class="dismiss-button"
                @click="dismissCookiesBanner"
            >
                <!--                        TODO Translate-->
                Dismiss
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import ThLink from '@/components/ui/buttons/ThLink.vue'

defineProps<{
    isVisible: boolean
}>()

const emit = defineEmits<{
    (e: 'dismiss'): void
}>()

function dismissCookiesBanner() {
    emit('dismiss')
}
</script>
